module.exports = __webpack_public_path__ + "img/c56.7bd37e4c.png";